import { createWebHistory, createRouter } from 'vue-router';

const routes = [
    // ----------------------------------------------------------------
    // Dashboard
    // ----------------------------------------------------------------
    {
        path: "/",
        name: "dashboard",
        component: () => import("./routes/Dashboard.vue"),
    },
    // ----------------------------------------------------------------
    // Templates
    // ----------------------------------------------------------------
    {
        path: "/templates",
        name: "templates",
        component: () => import("./routes/templates/TemplatesList.vue"),
    },
    {
        path: "/templates/create",
        name: "templates.create",
        component: () => import("./routes/templates/TemplateEditor.vue"),
    },
    {
        path: "/templates/:id/edit",
        name: "templates.edit",
        component: () => import("./routes/templates/TemplateEditor.vue"),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
